export default __webpack_public_path__ + "static/media/Tunic of the Putrescent.7e9f28b2.jpg";